// NOTE: Using Polyfill.io instead

// NOTE: Manual Polyfill for `Promise.all(…)`
// NOTE: This has to be placed before polyfill for `Promise.allSettled(…)` because it uses `Promise.all(…)`
if (!Promise.all) {
  Promise.all = function (promises) {
    return new Promise(function (fulfil, reject) {
      var result = []; var pending; var i; var processPromise

      if (!promises.length) {
        fulfil(result)
        return
      }

      processPromise = function (i) {
        promises[i].then(function (value) {
          result[i] = value

          if (!--pending) {
            fulfil(result)
          }
        }, reject)
      }

      pending = i = promises.length
      while (i--) {
        processPromise(i)
      }
    })
  }
}

// NOTE: Manual Polyfill for `Promise.allSettled(…)`
if (!Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map(
        function (promise) {
          return (
            promise
              .then(
                function (value) {
                  return {
                    status: 'fulfilled',
                    value: value
                  }
                }
              )
              .catch(
                function (reason) {
                  return {
                    status: 'rejected',
                    reason: reason
                  }
                }
              )
          )
        }
      )
    )
  }
}

// NOTE: Manual Polyfill for `Array.prototype.find`
if (!Array.prototype.find) {
  Object.defineProperty(
    Array.prototype,
    'find',
    {
      value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw TypeError('"this" is null or not defined')
        }

        var o = Object(this)

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw TypeError('predicate must be a function')
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1]

        // 5. Let k be 0.
        var k = 0

        // 6. Repeat, while k < len
        while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
          var kValue = o[k]
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue
          }
          // e. Increase k by 1.
          k++
        }

        // 7. Return undefined.
        return undefined
      },
      configurable: true,
      writable: true
    }
  )
}

// NOTE: Manual Polyfill for `Array.prototype.flatMap`
if (!Array.prototype.flatMap) {
  Object.defineProperty(
    Array.prototype,
    'flatMap',
    {
      configurable: true,
      value: function flatMap (callback) {
        return Array.prototype.map.apply(this, arguments).flat()
      },
      writable: true
    }
  )
}

// NOTE: Manual Polyfill for `Array.prototype.flat`
if (!Array.prototype.flat) {
  Object.defineProperty(
    Array.prototype,
    'flat',
    {
      configurable: true,
      value: function flat () {
        var depth = isNaN(arguments[0]) ? 1 : Number(arguments[0])

        return (
          depth
            ? Array.prototype.reduce.call(
              this,
              function (acc, cur) {
                if (Array.isArray(cur)) {
                  acc.push.apply(acc, flat.call(cur, depth - 1))
                } else {
                  acc.push(cur)
                }

                return acc
              },
              []
            )
            : Array.prototype.slice.call(this)
        )
      },
      writable: true
    }
  )
}

// NOTE: Manual Polyfill for `Object.fromEntries`
if (!Object.fromEntries) {
  Object.defineProperty(
    Object,
    'fromEntries',
    {
      value (entries) {
        if (!entries || !entries[Symbol.iterator]) {
          throw new Error('Object.fromEntries() requires a single iterable argument')
        }

        const o = {}

        Object.keys(entries)
          .forEach(
            key => {
              const [k, v] = entries[key]
              o[k] = v
            }
          )

        return o
      }
    }
  )
}
